import { FC } from "react";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";

interface LocationBreadcrumbsProps {
  state?: string;
  cityGoogle: string;
  stateGoogle: string;
  neighborhood?: string;
  neighborhoodBreadcrumb?: string;
  useTypeBreadcrumb: string;
  onClick?: () => void;
}

export const LocationBreadcrumbs: FC<LocationBreadcrumbsProps> = ({
  state,
  cityGoogle,
  stateGoogle,
  neighborhood,
  neighborhoodBreadcrumb,
  useTypeBreadcrumb,
  onClick,
}) => {
  const showNeighborhood = neighborhood && neighborhood !== cityGoogle;
  const safeStateGoogle =
    stateGoogle && stateGoogle !== "undefined" ? stateGoogle : "";
  const cityState =
    state && safeStateGoogle ? `${cityGoogle}, ${safeStateGoogle}` : cityGoogle;

  return (
    <div className="tw-mt-8">
      {showNeighborhood &&
        (neighborhoodBreadcrumb ? (
          <Button
            appearance="gray"
            variant="underline"
            href={neighborhoodBreadcrumb}
            onClick={onClick}
            data-testing-id="neighborhoodBreadcrumbLink"
          >
            {neighborhood}
            {cityState ? "," : ""}
          </Button>
        ) : (
          <Text data-testing-id="neighborhoodBreadcrumbText">
            {neighborhood}
            {cityState ? "," : ""}
          </Text>
        ))}

      {useTypeBreadcrumb ? (
        <Button
          appearance="gray"
          variant="underline"
          href={useTypeBreadcrumb}
          className="tw-ml-4"
          onClick={onClick}
          data-testing-id="listingCityCountryLink"
        >
          {cityState}
        </Button>
      ) : (
        <Text data-testing-id="listingCityCountryText" className="tw-ml-4">
          {cityState}
        </Text>
      )}
    </div>
  );
};
